import React from "react";
import { Navigate } from "react-router-dom";
import useUserStore from "../zustand/UseUserStore";
import Newsfeed from "../pages/Newsfeed";

const ConditionalHome = () => {
	const state = useUserStore();

	// If user is not signed in, show story landing page
	if (!state.userProgress.isAuthenticated) {
		return <Navigate to="/story-landing" replace />;
	}

	// If user is signed in and is a gamemaster, redirect to gamemaster page
	if (state.userProgress.isAuthenticated && state.isGamemaster) {
		return <Navigate to="/gamemaster" replace />;
	}

	// Otherwise, show the regular home page
	return <Newsfeed />;
};

export default ConditionalHome;
